import { Form } from "react-bootstrap";

import { ORGANIZATION_MENU_KEYS } from "../../helperData/organizationSidebar";

export const MENU_LABEL_KEYS = {
  reports: "reports.title",
  messages: "Messages.label",
  survey: "survey.menu.label",
  settings: "Settings.exp.label",
  customer_club: "Customer.club.label",
  restaurant: "SalesAndServices.Label",
};

const MenuAccessFields = ({
  t,
  value,
  onChange,
  showLabels = false,
  title,
  hint,
  idPrefix = "org",
}) => (
  <div className="org_menu_config">
    {title ? <div className="org_menu_config_title">{title}</div> : null}
    {hint ? <p className="org_menu_config_hint">{hint}</p> : null}
    {ORGANIZATION_MENU_KEYS.map((key) => {
      const item = value[key] || { enabled: false, label: "" };
      return (
        <div className={`org_menu_config_row${showLabels ? "" : " is_switch_only"}`} key={key}>
          <Form.Check
            type="switch"
            id={`${idPrefix}-menu-${key}`}
            checked={item.enabled === true}
            label={t(MENU_LABEL_KEYS[key])}
            onChange={(e) =>
              onChange({
                ...value,
                [key]: {
                  ...item,
                  enabled: e.target.checked,
                },
              })
            }
          />
          {showLabels ? (
            <Form.Control
              type="text"
              name={`menu_label_${key}`}
              autoComplete="off"
              value={item.label || ""}
              disabled={!item.enabled}
              maxLength={100}
              placeholder={`${t("OrgManagement.Menu.CustomLabel")}…`}
              onChange={(e) =>
                onChange({
                  ...value,
                  [key]: {
                    ...item,
                    label: e.target.value,
                  },
                })
              }
            />
          ) : null}
        </div>
      );
    })}
  </div>
);

export default MenuAccessFields;
